import React from 'react'
import Breadcrumbs from '../../components/Common/Breadcrumb';
import './formation.css';

export default function Formationad() {
  return (
    <>
               <React.Fragment>
            <div className="page-content">
                <Breadcrumbs
                    title="List Formation For Admin"
                    breadcrumbItems={[]}
                />
                
            </div>
        </React.Fragment>
    </>
  )
}
